import React, { useState } from "react";
import { Outlet } from "react-router-dom";

import Header from "../components/header";

import { ContentFullWrapper,  ScreenLayout } from "./style";
import { OrganizationContextProvider } from "../context/organization-context";

function LayoutFull() {
  React.useEffect(() => {
    const dynamicElement = document.getElementById("header");
    const handleScroll = () => {
      if (window.scrollY > 0) {
        dynamicElement.classList.add("sticky");
      } else {
        dynamicElement.classList.remove("sticky");
      }
    };
    window.addEventListener("scroll", handleScroll);
    // Clean up the event listener when the component unmounts
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const [isNavActive, setIsNavActive] = useState(false);
  // Toggle the nav state
  const toggleNav = () => {
    setIsNavActive(!isNavActive);
  };


  
  
  return (
    <OrganizationContextProvider>
      <ScreenLayout>
        <Header isNavActive={isNavActive} toggleNav={toggleNav} fullWidth/>
        <ContentFullWrapper>
          <Outlet />
        </ContentFullWrapper>
      </ScreenLayout>
    </OrganizationContextProvider>
  );
}

export default LayoutFull;
